<template>
  <div
    v-if="$store.getters.userId != ''"
    class="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 py-6 px-3"
  >
    <!-- Hero Section -->
    <div class="max-w-6xl mx-auto mb-6">
      <div class="text-center mb-6">
        <!-- <div class="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-[#fe5722] to-[#d84315] rounded-2xl mb-6 shadow-lg">
            <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
            </svg>
          </div> -->

        <p
          class="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed whitespace-pre-wrap"
        >
          የሽያጭ ዝርዝር መረጃ በማንበብ ሻጩን ያናግሩ። አዲስ የሚሸጥ ለመለጠፍ + ምልክትን ይጫኑ።
        </p>
        <!-- <p
          class="text-red-500 leading-relaxed whitespace-pre-wrap"
          style="font-size: 15px"
        >
          ልብ በሉ: ደላላ አናስተናግድም! አከራይ ወይም ተከራይ ደላላ ሁኖ ከተገኘ ምንም አይነት ክፍያ እንዳይከፍሉ።
          ለማንኛውም አይነት ችግር ቅሬታ ያቅርቡ።
        </p> -->
      </div>
    </div>

    <!-- Form Container -->
    <div class="max-w-4xl mx-auto">
      <div class="bg-white rounded-3xl shadow-2xl overflow-hidden">
        <!-- Form Header -->
        <div class="bg-gradient-to-r from-[#fe5722] to-[#d84315] px-2 py-6">
          <div class="justify-between flex items-center space-x-3">
            <div>
              <h2 class="text-2xl font-bold text-white ml-4">
                {{ "የሽያጭ ዝርዝር መረጃ" }}
              </h2>
              <p class="pl-2 text-sm text-white mt-1">የሚሸጥ ለመለጠፍ + ምልክቱን ይጫኑ</p>
            </div>
            <div
              @click="
                $router
                  .push({
                    name: 'home',
                  })
                  .catch((err) => {})
              "
              class="w-12 h-12 bg-white bg-opacity-20 rounded-xl flex items-center justify-center"
            >
              <svg
                class="w-6 h-6 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                ></path>
              </svg>
            </div>
          </div>
        </div>

        <!-- Form Content -->
        <div class="p-2 md:p-6">
          <!-- Enhanced Loading State -->
          <div
            v-if="loading"
            class="flex flex-col justify-center items-center h-64 space-y-4"
          >
            <div class="relative">
              <div
                class="w-16 h-16 border-4 border-orange-200 rounded-full animate-spin"
              ></div>
              <div
                class="absolute top-0 left-0 w-16 h-16 border-4 border-transparent border-t-orange-600 rounded-full animate-spin"
              ></div>
            </div>
            <div class="text-center">
              <h3 class="text-lg font-semibold text-gray-700 mb-2">
                Loading...
              </h3>
              <p class="text-gray-500">እባክዎን ትንሽ ይጠብቁ</p>
            </div>
          </div>
          <div
            v-else-if="!rentals || rentals.length === 0"
            class="p-10 text-center text-gray-600"
          >
            <div
              class="mx-auto w-12 h-12 mb-3 rounded-full bg-blue-50 flex items-center justify-center"
            >
              <svg
                class="w-6 h-6 text-blue-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"
                />
              </svg>
            </div>
            <p class="text-lg font-semibold text-gray-800">ምንም ውጤት አልተገኘም</p>
            <p class="text-sm text-gray-500 mt-1">ተሽጧል</p>
          </div>
          <!-- Enhanced Error State -->
          <div
            v-if="error"
            class="bg-red-50 border border-red-200 rounded-xl p-6 text-center"
          >
            <div class="flex justify-center mb-4">
              <div
                class="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center"
              >
                <svg
                  class="w-6 h-6 text-red-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
              </div>
            </div>
            <h3 class="text-lg font-semibold text-red-800 mb-2">
              Error Loading Sale
            </h3>
            <p class="text-red-600 mb-4">{{ error.message }}</p>
            <button
              @click="fetchSingleRental"
              class="bg-red-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-red-700 transition-colors duration-200"
            >
              እባክዎን እንደገና ይሞክሩ
            </button>
          </div>
          <div class="grid gap-6 md:gap-8" v-if="rentals && rentals.length">
            <div
              v-for="rental in rentals"
              :key="rental.rent_id"
              class="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-blue-200"
            >
              <!-- Enhanced Media Gallery with Preview -->
              <div
                class="relative bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 rounded-t-2xl overflow-hidden"
              >
                <!-- Main Gallery Container -->
                <div class="relative">
                  <!-- Navigation Direction Indicators (Visual Only) -->
                  <div
                    v-if="
                      currentRental &&
                      currentRentalImages.length + currentRentalVideos.length >
                        1 &&
                      activeSlide > 0
                    "
                    class="absolute left-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/70 backdrop-blur-sm rounded-full shadow-lg flex items-center justify-center pointer-events-none"
                  >
                    <svg
                      class="w-5 h-5 text-gray-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 19l-7-7 7-7"
                      />
                    </svg>
                  </div>

                  <div
                    v-if="
                      currentRental &&
                      currentRentalImages.length + currentRentalVideos.length >
                        1 &&
                      activeSlide <
                        currentRentalImages.length +
                          currentRentalVideos.length -
                          1
                    "
                    class="absolute right-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white/70 backdrop-blur-sm rounded-full shadow-lg flex items-center justify-center pointer-events-none"
                  >
                    <svg
                      class="w-5 h-5 text-gray-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </div>

                  <!-- Main Media Display -->
                  <div
                    class="flex overflow-x-auto space-x-4 px-4 py-4 snap-x snap-mandatory scrollbar-hide scroll-smooth"
                    @scroll="updateActiveSlide"
                    ref="mediaGallery"
                  >
                    <!-- Images -->
                    <template v-for="(img, index) in currentRentalImages">
                      <div
                        v-if="img && img.trim() !== ''"
                        :key="'img-' + index"
                        class="flex-shrink-0 relative group snap-center"
                        :data-index="index"
                      >
                        <div
                          class="w-[90vw] sm:w-80 md:w-96 lg:w-[28rem] xl:w-[32rem] h-48 sm:h-52 md:h-56 lg:h-60 xl:h-64 bg-white rounded-2xl shadow-xl overflow-hidden cursor-pointer transform hover:scale-[1.02] transition-all duration-300 border border-white/50"
                          @click="openImageModal(index)"
                        >
                          <img
                            :src="img"
                            class="w-full h-full object-cover"
                            alt="Rental image"
                          />
                          <!-- Hover Overlay -->
                          <div
                            class="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300 flex items-center justify-center"
                          >
                            <div
                              class="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white/90 backdrop-blur-sm rounded-full p-3"
                            >
                              <svg
                                class="w-6 h-6 text-gray-700"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <!-- Media Counter Badge -->
                        <div
                          class="absolute top-4 right-4 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm px-3 py-1.5 rounded-full font-semibold shadow-lg"
                        >
                          {{ index + 1 }}
                        </div>
                      </div>
                    </template>

                    <!-- Videos -->
                    <template v-for="(vid, index) in currentRentalVideos">
                      <div
                        v-if="vid && vid.trim() !== ''"
                        :key="'vid-' + index"
                        class="flex-shrink-0 relative group snap-center"
                        :data-index="currentRentalImages.length + index"
                      >
                        <div
                          class="w-[90vw] sm:w-80 md:w-96 lg:w-[28rem] xl:w-[32rem] h-48 sm:h-52 md:h-56 lg:h-60 xl:h-64 bg-white rounded-2xl shadow-xl overflow-hidden cursor-pointer transform hover:scale-[1.02] transition-all duration-300 border border-white/50"
                          @click="openVideoModal(index)"
                        >
                          <video
                            :src="vid"
                            class="w-full h-full object-cover rounded-2xl"
                            controls
                          ></video>
                        </div>
                        <!-- Video Badge -->
                        <div
                          class="absolute top-4 right-4 bg-gradient-to-r from-red-500 to-red-600 text-white text-sm px-3 py-1.5 rounded-full font-semibold flex items-center shadow-lg"
                        >
                          <svg
                            class="w-4 h-4 mr-1.5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M8 5v10l7-5-7-5z" />
                          </svg>
                          Video
                        </div>
                      </div>
                    </template>
                  </div>
                </div>

                <!-- Enhanced Dot Indicators -->
                <div class="flex justify-center pb-4 pt-2 space-x-2">
                  <template
                    v-for="(item, index) in [
                      ...currentRentalImages,
                      ...currentRentalVideos,
                    ]"
                    :key="'dot-' + index"
                  >
                    <button
                      @click="scrollToSlide(index)"
                      @mousedown="console.log('Dot clicked:', index)"
                      :class="[
                        'transition-all duration-300 rounded-full cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50',
                        activeSlide === index
                          ? 'w-8 h-3 bg-gradient-to-r from-blue-500 to-blue-600 shadow-lg'
                          : 'w-3 h-3 bg-gray-300 hover:bg-gray-400 hover:shadow-md hover:scale-110',
                      ]"
                      :aria-label="`Go to slide ${index + 1}`"
                      type="button"
                    ></button>
                  </template>
                </div>
              </div>
              <!-- Rental Details -->
              <div class="p-6">
                <div class="mb-4">
                  <h3 class="text-2xl font-bold text-gray-900 mb-2">
                    {{ rental.title }}
                  </h3>
                </div>

                <!-- Status and Posted Date Row -->
                <div class="flex items-center justify-between mb-4">
                  <div>
                    <span
                      v-if="Number(rental.isapproved) === 1"
                      class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700"
                    >
                      <svg
                        class="w-3.5 h-3.5 mr-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      Active
                    </span>
                    <span
                      v-else-if="Number(rental.isapproved) === 2"
                      class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-700"
                    >
                      <svg
                        class="w-3.5 h-3.5 mr-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                      Rejected
                    </span>
                    <span
                      v-else
                      class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-700"
                    >
                      <svg
                        class="w-3.5 h-3.5 mr-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      Pending
                    </span>
                  </div>
                  <div class="flex items-center text-xs text-gray-600">
                    <svg
                      class="w-4 h-4 mr-1.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    <span>{{ formatDate(rental.posted_date) }}</span>
                  </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                  <div class="flex items-start space-x-3">
                    <div
                      class="flex-shrink-0 w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center"
                    >
                      <svg
                        class="w-4 h-4 text-green-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        ></path>
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <p class="text-sm font-medium text-gray-500">አድራሻ</p>
                      <p class="text-gray-900 font-semibold">
                        {{ rental.address }}
                      </p>
                    </div>
                  </div>

                  <div class="flex items-start space-x-3">
                    <div
                      class="flex-shrink-0 w-8 h-8 bg-yellow-100 rounded-lg flex items-center justify-center"
                    >
                      <svg
                        class="w-4 h-4 text-yellow-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <p class="text-sm font-medium text-gray-500">ዋጋ</p>
                      <p class="text-gray-900 font-bold text-lg">
                        {{ formatNumber(rental.price) }} ብር
                      </p>
                    </div>
                  </div>

                  <!-- <div class="flex items-start space-x-3">
                      <div class="flex-shrink-0 w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
                        <svg class="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                        </svg>
                      </div>
                      <div>
                        <p class="text-sm font-medium text-gray-500">ስልክ ቁጥር</p>
                        <p class="text-gray-900 font-semibold">{{ rental.phone }}</p>
                      </div>
                    </div> -->
                </div>

                <div v-if="rental.description" class="mb-6">
                  <h4 class="text-gray-900 font-bold text-lg mb-2">
                    <strong>ዝርዝር መግለጫ</strong>
                  </h4>
                  <p class="text-gray-700 leading-relaxed whitespace-pre-wrap">
                    {{ rental.description.replace(/\\n/g, "\n") }}
                  </p>
                </div>
              </div>

              <!-- Contact Section -->
              <div class="px-6 pb-6 space-y-3">
                <div
                  class="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-100"
                >
                  <button
                    @click="initiatePhoneCall(rental.phone)"
                    class="flex items-center justify-center space-x-2 text-blue-700 w-full hover:text-blue-800 transition-colors duration-200"
                  >
                    <svg
                      class="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                      ></path>
                    </svg>
                    <span class="font-semibold">ባለቤቱ ጋ ይደውሉ</span>
                  </button>
                </div>
                <div
                  class="bg-gradient-to-r from-red-50 to-pink-50 rounded-xl p-4 border border-red-100"
                >
                  <button
                    @click="openComplaintModal"
                    class="flex items-center justify-center space-x-2 text-red-700 w-full hover:text-red-800 transition-colors duration-200"
                  >
                    <svg
                      class="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L4.268 16.5c-.77.833.192 2.5 1.732 2.5z"
                      ></path>
                    </svg>
                    <span class="font-semibold">ቅሬታ ያቅርቡ</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Refresh Button -->
          <div class="flex justify-center mt-8">
            <button
              @click="fetchSingleRental"
              :disabled="loading"
              class="bg-gradient-to-r from-orange-500 to-orange-700 text-white font-semibold py-3 px-6 rounded-xl shadow-lg hover:from-orange-600 hover:to-orange-800 hover:shadow-xl transition-all duration-200 flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg
                v-if="loading"
                class="w-5 h-5 animate-spin"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                ></path>
              </svg>
              <svg
                v-else
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                ></path>
              </svg>
              <span>{{ loading ? "Loading..." : "Refresh" }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Enhanced Media Modal with Zoom -->
  <transition name="modal-drop">
    <div
      v-if="showModal"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90"
      @click="closeMediaModal"
    >
      <div class="relative max-w-7xl max-h-full p-4" @click.stop>
        <!-- Close Button -->
        <button
          @click="closeMediaModal"
          class="absolute top-4 right-4 z-10 w-10 h-10 bg-black/70 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-black/80 transition-colors duration-200 shadow-lg border border-white/20"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            stroke-width="2.5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <!-- Zoom Controls -->
        <div class="absolute top-4 left-4 z-10">
          <button
            @click="resetZoom"
            class="w-10 h-10 bg-black/70 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-black/80 transition-colors duration-200 shadow-lg border border-white/20"
            title="Reset Zoom"
          >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              stroke-width="2.5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
          </button>
        </div>

        <!-- Media Content -->
        <div class="relative overflow-hidden rounded-lg">
          <transition name="fade-slide" mode="out-in">
            <div
              :key="
                modalMedia.type === 'image'
                  ? 'img-' + modalImageIndex
                  : 'vid-' + modalMedia.src
              "
              class="transform transition-transform duration-200 ease-out cursor-move"
              :style="{
                transform: `scale(${zoomLevel}) translate(${imagePosition.x}px, ${imagePosition.y}px)`,
              }"
              @mousedown="startDrag"
              @mousemove="drag"
              @mouseup="endDrag"
              @mouseleave="endDrag"
              @touchstart="handleTouchStart"
              @touchmove="handleTouchMove"
              @touchend="handleTouchEnd"
            >
              <img
                v-if="modalMedia.type === 'image'"
                :src="modalMedia.src"
                class="max-w-full max-h-[80vh] object-contain"
                alt="Rental image"
                draggable="false"
              />
              <video
                v-else-if="modalMedia.type === 'video'"
                :src="modalMedia.src"
                class="max-w-full max-h-[80vh] object-contain"
                controls
                autoplay
              ></video>
            </div>
          </transition>
          <!-- Prev/Next controls visible when images exist -->
          <button
            v-if="
              modalMedia.type === 'image' &&
              currentRentalImages.length > 1 &&
              modalImageIndex > 0
            "
            @click="prevImage"
            class="absolute left-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-black/50 rounded-full flex items-center justify-center text-white"
            title="Previous"
          >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <button
            v-if="
              modalMedia.type === 'image' &&
              currentRentalImages.length > 1 &&
              modalImageIndex < currentRentalImages.length - 1
            "
            @click="nextImage"
            class="absolute right-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-black/50 rounded-full flex items-center justify-center text-white"
            title="Next"
          >
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
          <!-- Index indicator -->
          <div
            v-if="modalMedia.type === 'image' && currentRentalImages.length > 1"
            class="absolute top-4 left-1/2 -translate-x-1/2 bg-black/60 text-white text-xs font-medium px-3 py-1 rounded-full z-10 border border-white/10"
          >
            {{ modalImageIndex + 1 }} / {{ currentRentalImages.length }}
          </div>
        </div>

        <!-- Zoom Level Indicator -->
        <div
          class="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black/70 backdrop-blur-sm rounded-full px-4 py-2 text-white text-sm font-medium shadow-lg border border-white/20"
        >
          {{ Math.round(zoomLevel * 100) }}%
        </div>
      </div>
    </div>
  </transition>

  <!-- Complaint Modal -->
  <transition name="modal-drop">
    <div
      v-if="showComplaintModal"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      @click="closeComplaintModal"
    >
      <div
        class="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4"
        @click.stop
      >
        <!-- Modal Header -->
        <div
          class="bg-gradient-to-r from-red-500 to-pink-600 px-6 py-4 rounded-t-2xl"
        >
          <div class="flex items-center justify-between">
            <h3 class="text-xl font-bold text-white">ቅሬታ ያቅርቡ</h3>
            <button
              @click="closeComplaintModal"
              class="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors duration-200"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        <!-- Modal Content -->
        <div class="p-6">
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              ችግር ወይም ቅሬታዎን ይግለጹ
            </label>
            <textarea
              v-model="complaintText"
              rows="4"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none resize-none"
              placeholder="ችግርዎን ወይም ቅሬታዎን በዝርዝር ይግለጹ..."
            ></textarea>
          </div>

          <div class="flex space-x-3">
            <button
              @click="closeComplaintModal"
              class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors duration-200"
            >
              ይቅር
            </button>
            <button
              @click="submitComplaint"
              :disabled="!complaintText.trim() || isSubmittingComplaint"
              class="flex-1 px-4 py-2 bg-gradient-to-r from-red-500 to-pink-600 text-white rounded-lg hover:from-red-600 hover:to-pink-700 disabled:cursor-not-allowed transition-all duration-200 flex items-center justify-center space-x-2"
            >
              <svg
                v-if="isSubmittingComplaint"
                class="w-4 h-4 animate-spin"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
              <span>{{ isSubmittingComplaint ? "በመላክ..." : "ቅሬታ ያቅርቡ" }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { apolloClient } from "@/apollo"; // your Apollo client instance
import { gql } from "@apollo/client/core";
import { toast } from "@/toast";

export default {
  data() {
    return {
      rentals: [],
      loading: false,
      error: null,
      isExpanded: {},
      activeSlide: 0,
      showModal: false,
      modalMedia: {
        src: "",
        type: "",
      },
      modalImageIndex: 0,
      showComplaintModal: false,
      complaintText: "",
      isSubmittingComplaint: false,
      zoomLevel: 1,
      isDragging: false,
      dragStart: { x: 0, y: 0 },
      imagePosition: { x: 0, y: 0 },
      // Touch gesture properties
      initialTouchDistance: 0,
      initialZoomLevel: 1,
    };
  },

  computed: {
    // Safe getter for current rental
    currentRental() {
      return this.rentals && this.rentals.length > 0 ? this.rentals[0] : null;
    },

    // Safe getter for current rental images
    currentRentalImages() {
      return this.currentRental && this.currentRental.images
        ? this.currentRental.images
            .split(",")
            .filter((i) => i && i.trim() !== "")
        : [];
    },

    // Safe getter for current rental videos
    currentRentalVideos() {
      return this.currentRental && this.currentRental.videos
        ? this.currentRental.videos
            .split(",")
            .filter((v) => v && v.trim() !== "")
        : [];
    },
  },

  watch: {
    rentals: {
      handler(newRentals) {
        // Reset active slide when rentals change
        if (newRentals && newRentals.length > 0) {
          this.activeSlide = 0;
        }
      },
      immediate: true,
    },
  },

  methods: {
    formatNumber(num) {
      return new Intl.NumberFormat().format(num);
    },
    updateActiveSlide(event) {
      const container = event.target;
      if (container.children.length === 0) return;

      const slideWidth = container.children[0]?.offsetWidth + 16; // width + gap (space-x-4)
      const scrollLeft = container.scrollLeft;
      const newActiveSlide = Math.round(scrollLeft / slideWidth);
      this.activeSlide = Math.max(
        0,
        Math.min(newActiveSlide, container.children.length - 1)
      );
    },

    scrollToSlide(index) {
      this.$nextTick(() => {
        const container = this.$refs.mediaGallery;
        if (!container) return;

        const children = container.children;
        if (!children || children.length === 0) return;

        const targetChild = children[index];
        if (!targetChild) return;

        // Try scrollIntoView first
        try {
          targetChild.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        } catch (e) {
          // Fallback to manual scroll calculation
          const scrollLeft =
            targetChild.offsetLeft -
            container.offsetWidth / 2 +
            targetChild.offsetWidth / 2;
          container.scrollTo({
            left: Math.max(0, scrollLeft),
            behavior: "smooth",
          });
        }

        // Update active slide
        this.activeSlide = index;
      });
    },
    // Initiate phone call and track in database
    async initiatePhoneCall(phoneNumber) {
      // Validate that we have the required data
      if (!this.currentRental?.rent_id) {
        toast.error("የሽያጭ መረጃ አልተገኘም። እባክዎን እንደገና ይሞክሩ።");
        return;
      }

      if (!this.$store.getters.userId) {
        toast.error("የተጠቃሚ መረጃ አልተገኘም። እባክዎን እንደገና ይግቡ።");
        return;
      }

      try {
        // Track phone call click in database

        // Clean the phone number (remove spaces, dashes, etc.)
        const cleanNumber = phoneNumber.replace(/[\s\-()]/g, "");

        // Copy phone number to clipboard and show toast
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(cleanNumber);
          } else {
            const input = document.createElement("input");
            input.value = cleanNumber;
            input.style.position = "fixed";
            input.style.opacity = "0";
            document.body.appendChild(input);
            input.select();
            document.execCommand("copy");
            document.body.removeChild(input);
          }
          toast.success("Phone number copied");
        } catch (copyErr) {
          // Non-blocking if copy fails
        }

        // Prefer Telegram WebApp API if available, else fallback to tel:
        const telUrl = `tel:${cleanNumber}`;
        if (window.Telegram?.WebApp?.openLink) {
          try {
            window.Telegram.WebApp.openLink(telUrl, {
              try_instant_view: false,
            });
          } catch (e) {
            // Fallbacks inside Telegram
            try {
              window.location.href = telUrl;
            } catch (_) {
              const link = document.createElement("a");
              link.href = telUrl;
              link.style.display = "none";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }
        } else {
          // Regular browsers: use tel: protocol
          const link = document.createElement("a");
          link.href = telUrl;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          try {
            window.location.href = telUrl;
          } catch (e) {
            toast.info(`ስልክ ለመደወል: ${phoneNumber}`);
          }
        }
        await this.trackPhoneCall();
      } catch (error) {
        console.error("Error tracking phone call:", error);
        // Still proceed with the phone call even if tracking fails
        const cleanNumber = phoneNumber.replace(/[\s\-()]/g, "");
        const telUrl = `tel:${cleanNumber}`;
        window.location.href = telUrl;
      }
    },

    // Track phone call in database using GraphQL - store rental_id and the 2 user IDs
    async trackPhoneCall() {
      const TRACK_PHONE_CALL = gql`
        mutation TrackPhoneCall(
          $rental_id: ID
          $rental_owner_id: String!
          $caller_id: String!
          $called_date: String!
        ) {
          trackPhoneCall(
            rental_id: $rental_id
            rental_owner_id: $rental_owner_id
            caller_id: $caller_id
            called_date: $called_date
          ) {
            id
            rental_id
            rental_owner_id
            caller_id
            called_date
            created_at
          }
        }
      `;

      const variables = {
        rental_id: this.currentRental.rent_id,
        rental_owner_id: this.currentRental.user_id,
        caller_id: this.$store.getters.userId,
        called_date: new Date().toISOString(),
      };

      try {
        const result = await apolloClient.mutate({
          mutation: TRACK_PHONE_CALL,
          variables: variables,
          errorPolicy: "all",
        });

        return result.data.trackPhoneCall;
      } catch (error) {
        console.error("Error tracking phone call:", error);
        throw error;
      }
    },

    // Complaint modal functions
    openComplaintModal() {
      this.showComplaintModal = true;
      this.complaintText = "";
      document.body.style.overflow = "hidden";
    },

    closeComplaintModal() {
      this.showComplaintModal = false;
      this.complaintText = "";
      document.body.style.overflow = "";
    },

    async submitComplaint() {
      if (!this.complaintText.trim()) {
        toast.warning("እባክዎን ቅሬታዎን ይግለጹ");
        return;
      }

      // Validate that we have the required data
      if (!this.currentRental?.rent_id) {
        toast.error("የሽያጭ መረጃ አልተገኘም። እባክዎን እንደገና ይሞክሩ።");
        return;
      }

      if (!this.$store.getters.userId) {
        toast.error("የተጠቃሚ መረጃ አልተገኘም። እባክዎን እንደገና ይግቡ።");
        return;
      }

      this.isSubmittingComplaint = true;

      try {
        const SUBMIT_COMPLAINT = gql`
          mutation SubmitComplaint(
            $rental_id: ID!
            $rental_owner_id: String!
            $reporter_id: String!
            $complaint_text: String!
            $reported_date: String!
            $status: String!
          ) {
            submitComplaint(
              rental_id: $rental_id
              rental_owner_id: $rental_owner_id
              reporter_id: $reporter_id
              complaint_text: $complaint_text
              reported_date: $reported_date
              status: $status
            ) {
              id
              rental_id
              rental_owner_id
              reporter_id
              complaint_text
              reported_date
              status
              created_at
            }
          }
        `;

        const variables = {
          rental_id: this.currentRental.rent_id,
          rental_owner_id: this.currentRental.user_id,
          reporter_id: this.$store.getters.userId,
          complaint_text: this.complaintText.trim(),
          reported_date: new Date().toISOString(),
          status: "pending",
        };

        const result = await apolloClient.mutate({
          mutation: SUBMIT_COMPLAINT,
          variables: variables,
          errorPolicy: "all",
        });

        if (result.data && result.data.submitComplaint) {
          toast.success("ቅሬታዎ በተሳካ ሁኔታ ተመዝግቧል። በቅርቡ እናገኝዎታለን።");
          this.closeComplaintModal();
        } else {
          throw new Error("Failed to submit complaint");
        }
      } catch (error) {
        console.error("Error submitting complaint:", error);
        toast.error("ቅሬታ ማስገባት አልተሳካም። እባክዎን እንደገና ይሞክሩ።");
      } finally {
        this.isSubmittingComplaint = false;
      }
    },

    openMediaModal(src, type) {
      this.modalMedia.src = src;
      this.modalMedia.type = type;
      this.showModal = true;
      this.resetZoom();
      // Prevent body scroll when modal is open
      document.body.style.overflow = "hidden";
    },

    openImageModal(index) {
      const images = this.currentRentalImages;
      if (!images.length) return;
      const clamped = Math.max(0, Math.min(index, images.length - 1));
      this.modalImageIndex = clamped;
      this.openMediaModal(images[clamped], "image");
    },

    openVideoModal(index) {
      const videos = this.currentRentalVideos;
      if (!videos.length) return;
      const clamped = Math.max(0, Math.min(index, videos.length - 1));
      this.openMediaModal(videos[clamped], "video");
    },

    closeMediaModal() {
      this.showModal = false;
      this.modalMedia.src = "";
      this.modalMedia.type = "";
      this.resetZoom();
      // Restore body scroll
      document.body.style.overflow = "";
    },

    // Zoom functionality
    resetZoom() {
      this.zoomLevel = 1;
      this.imagePosition = { x: 0, y: 0 };
      this.isDragging = false;
    },

    // Drag functionality for zoomed images
    startDrag(event) {
      if (this.zoomLevel <= 1) return;
      this.isDragging = true;
      this.dragStart = { x: event.clientX, y: event.clientY };
      event.preventDefault();
    },

    drag(event) {
      if (!this.isDragging || this.zoomLevel <= 1) return;

      const deltaX = event.clientX - this.dragStart.x;
      const deltaY = event.clientY - this.dragStart.y;

      this.imagePosition = {
        x: this.imagePosition.x + deltaX,
        y: this.imagePosition.y + deltaY,
      };

      this.dragStart = { x: event.clientX, y: event.clientY };
      event.preventDefault();
    },

    endDrag() {
      this.isDragging = false;
    },

    // Touch gesture methods for pinch zoom
    handleTouchStart(event) {
      if (event.touches.length === 2) {
        // Two finger pinch gesture
        const touch1 = event.touches[0];
        const touch2 = event.touches[1];
        this.initialTouchDistance = this.getTouchDistance(touch1, touch2);
        this.initialZoomLevel = this.zoomLevel;
        event.preventDefault();
      } else if (event.touches.length === 1 && this.zoomLevel > 1) {
        // Single finger drag when zoomed
        const touch = event.touches[0];
        this.isDragging = true;
        this.dragStart = { x: touch.clientX, y: touch.clientY };
        event.preventDefault();
      }
    },

    handleTouchMove(event) {
      if (event.touches.length === 2) {
        // Two finger pinch gesture
        const touch1 = event.touches[0];
        const touch2 = event.touches[1];
        const currentDistance = this.getTouchDistance(touch1, touch2);

        if (this.initialTouchDistance > 0) {
          const scale = currentDistance / this.initialTouchDistance;
          const newZoomLevel = this.initialZoomLevel * scale;
          this.zoomLevel = Math.max(0.1, Math.min(5, newZoomLevel));
        }
        event.preventDefault();
      } else if (
        event.touches.length === 1 &&
        this.isDragging &&
        this.zoomLevel > 1
      ) {
        // Single finger drag when zoomed
        const touch = event.touches[0];
        const deltaX = touch.clientX - this.dragStart.x;
        const deltaY = touch.clientY - this.dragStart.y;

        this.imagePosition = {
          x: this.imagePosition.x + deltaX,
          y: this.imagePosition.y + deltaY,
        };

        this.dragStart = { x: touch.clientX, y: touch.clientY };
        event.preventDefault();
      } else if (event.touches.length === 1 && this.zoomLevel <= 1) {
        // Interpret horizontal swipe to navigate between images when not zoomed
        const touch = event.touches[0];
        const deltaX = touch.clientX - (this.dragStart.x || touch.clientX);
        // If dragStart not set (first move), set it and return
        if (!this.dragStart.x && !this.dragStart.y) {
          this.dragStart = { x: touch.clientX, y: touch.clientY };
          return;
        }
        // Threshold for swipe
        const SWIPE_THRESHOLD = 40;
        if (
          Math.abs(deltaX) > SWIPE_THRESHOLD &&
          this.modalMedia.type === "image"
        ) {
          if (deltaX < 0) {
            this.nextImage();
          } else {
            this.prevImage();
          }
          // reset dragStart to avoid multi-advance
          this.dragStart = { x: touch.clientX, y: touch.clientY };
          event.preventDefault();
        }
      }
    },

    handleTouchEnd() {
      this.isDragging = false;
      this.initialTouchDistance = 0;
      this.initialZoomLevel = 1;
      this.dragStart = { x: 0, y: 0 };
    },

    getTouchDistance(touch1, touch2) {
      const dx = touch1.clientX - touch2.clientX;
      const dy = touch1.clientY - touch2.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    },

    nextImage() {
      if (this.modalMedia.type !== "image") return;
      const total = this.currentRentalImages.length;
      if (total === 0) return;
      const next = Math.min(this.modalImageIndex + 1, total - 1);
      this.modalImageIndex = next;
      this.modalMedia.src = this.currentRentalImages[next];
      this.resetZoom();
    },

    prevImage() {
      if (this.modalMedia.type !== "image") return;
      const total = this.currentRentalImages.length;
      if (total === 0) return;
      const prev = Math.max(this.modalImageIndex - 1, 0);
      this.modalImageIndex = prev;
      this.modalMedia.src = this.currentRentalImages[prev];
      this.resetZoom();
    },

    async fetchSingleRental() {
      this.loading = true;
      this.error = null;
      const rent_id = this.$route.params?.id;
      const GET_ONE = gql`
        query GetRental($rent_id: ID!) {
          rental(rent_id: $rent_id) {
            rent_id
            title
            address
            price
            phone
            description

            images
            videos
            isapproved
            posted_date
            message_id
            bank_slip
            user_id
          }
        }
      `;
      try {
        const result = await apolloClient.query({
          query: GET_ONE,
          variables: { rent_id },
          fetchPolicy: "no-cache",
        });
        const item = result.data?.rental ? [result.data.rental] : [];
        this.rentals = item;
      } catch (e) {
        this.error = e;
        toast.error(e.message || "ምንም ውጤት አልተገኘም። እባክዎን እንደገና ይሞክሩ");
      } finally {
        this.loading = false;
      }
    },
    toggleExpand(id) {
      this.$set
        ? this.$set(this.isExpanded, id, !this.isExpanded[id])
        : (this.isExpanded = {
            ...this.isExpanded,
            [id]: !this.isExpanded[id],
          });
    },

    formatDate(input) {
      if (!input) return "-";

      let date;
      // If it's a number or numeric string, treat as UNIX timestamp
      if (
        typeof input === "number" ||
        (typeof input === "string" && /^\d+$/.test(input))
      ) {
        const num = Number(input);
        // If seconds (10 digits), convert to ms
        const ms = String(num).length === 10 ? num * 1000 : num;
        date = new Date(ms);
      } else {
        // Try to parse ISO/MySQL datetime string
        const parsed = Date.parse(input);
        date = isNaN(parsed) ? null : new Date(parsed);
      }

      if (!date || isNaN(date.getTime())) return "-";

      const pad = (n) => String(n).padStart(2, "0");
      const yyyy = String(date.getFullYear());
      const mm = pad(date.getMonth() + 1);
      const dd = pad(date.getDate());
      const hh = pad(date.getHours());
      const min = pad(date.getMinutes());
      const ss = pad(date.getSeconds());
      return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
    },
  },

  async mounted() {
    await this.fetchSingleRental();
  },

  beforeUnmount() {
    // Ensure body scroll is restored when component is destroyed
    document.body.style.overflow = "";
  },
};
</script>

<style scoped>
/* Hide scrollbars for gallery */
.scrollbar-hide {
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.scrollbar-hide::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}

/* Smooth scroll behavior */
.scroll-smooth {
  scroll-behavior: smooth;
}

/* Custom backdrop blur for better browser support */
.backdrop-blur-sm {
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

/* Enhanced hover effects */
.group:hover .group-hover\:scale-\[1\.02\] {
  transform: scale(1.02);
}

/* Custom gradient animations */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.animate-shimmer {
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  background-size: 200% 100%;
  animation: shimmer 2s infinite;
}

/* Modal media smooth transition */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 220ms ease;
}
.fade-slide-enter-from {
  opacity: 0;
  transform: translateX(20px);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>
